import React from 'react';
import strings from 'strings';
import * as styles from './SafetyBanner.scss';

import { BannerMobile } from '../Banner';

const SafetyBannerMobile = (props) => {
  const {
    safetyLandingUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <BannerMobile
      url={safetyLandingUrl}
      closeBanner={closeBanner}
      primaryText={strings.safetyBannerPrimary}
      secondaryText={strings.safetyBannerSecondary}
      buttonText={strings.safetyBannerBtn}
      imageUrl={imageUrl}
      imageAlt="safety-image"
      className={styles.safetyBanner}
    />
  );
};

export default SafetyBannerMobile;
